module.exports = __webpack_public_path__ + "img/hero-sp@2x.a936c632.webp";